var _style, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSave(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "27.8px",
    height: "28px",
    viewBox: "0 0 27.8 28",
    style: {
      enableBackground: "new 0 0 27.8 28"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.star{fill:#FFFFFF;}\n\t.circle{fill:#0FB5F9;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "iPads"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "circle",
    cx: 13.9,
    cy: 14,
    r: 13.3
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "star",
    d: "M18.6,21.5c-0.1,0-0.3,0-0.4-0.1l-4.3-3.2l-4.3,3.2c-0.2,0.2-0.5,0.2-0.8,0c-0.2-0.2-0.3-0.5-0.2-0.8 l1.6-5.2l-4.4-3.3c-0.2-0.2-0.3-0.5-0.2-0.8c0.1-0.3,0.3-0.5,0.6-0.5h5.4l1.7-5.3c0.2-0.6,1.1-0.6,1.3,0l1.7,5.3h5.4 c0.3,0,0.5,0.2,0.6,0.5c0.1,0.3,0,0.6-0.2,0.8l-4.4,3.3l1.6,5.2c0.1,0.3,0,0.6-0.2,0.8C18.8,21.5,18.7,21.5,18.6,21.5z"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSave);
export default __webpack_public_path__ + "static/media/save.c5d4cac5cf352df9e595c53d9e2dc38a.svg";
export { ForwardRef as ReactComponent };